import { PrivacyTypes, ProfileV2 } from '../../../types';

function getProfileTypes({
  hasResume,
  profilePrivacy,
  approachabilitySignal,
  workHistories,
  profileType,
}: ProfileV2) {
  return [
    hasResume && profilePrivacy.toString() === PrivacyTypes.Standard
      ? 'cv_available'
      : 'cv_unavailable',
    profilePrivacy,
    approachabilitySignal && approachabilitySignal === 2
      ? 'approachability_signal'
      : 'none',
    workHistories && workHistories.find((w) => w.foundInCV)
      ? 'role_found_in_cv'
      : 'none',
    profileType,
  ];
}

export default getProfileTypes;
